const imgHomeAbout = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingAiMain1 = "./assets/figma/52a8fd9d-db80-4ff0-a4d5-66c04e7ab394.png";
const img1 = "./assets/figma/10c9e57a-3d9e-46bd-aa90-dd15d7868e23.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine27 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";

export default function HomeAbout() {
  return (
    <div className="s0 s1" data-node-id="772:278" data-name="HOME_ABOUT">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s1068 s1" src={imgHomeAbout} />
      </div>
      <div className="s2 s1086 s1087 s1088" data-node-id="886:8" data-name="DING_AI_MAIN 1">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingAiMain1} />
      </div>
      <div className="s2 s16 s17 s24 s1089 s26 s1090 s1091 s1092" data-node-id="772:279">
        <div className="s23 s16 s17 s24 s172 s26 s27 s0 s28 s34" data-node-id="772:280">
          <p className="s31 s32 s0 s28 s1093 s1094 s34" data-node-id="772:281">
            DING AI LAB
          </p>
          <div className="s35 s36 s0 s28 s29 s1095 s34 s38" data-node-id="772:282">
            <p className="s1096 s40">{`DING AI LAB은 AI를 배우는 공간이 아니라, AI를 가지고 놀고 실험하며 `}</p>
            <p className="s1096 s40">새로운 가능성을 발견하는 플레이 랩(Play Lab)이다.</p>
            <p className="s1096 s40">​</p>
            <p className="s1096 s40">{`브랜드의 핵심 모티브인 구슬(Ball)은 AI를 상징한다. 하나의 구슬은 `}</p>
            <p className="s1096 s40">{`하나의 아이디어, 각기 다른 색상은 서로 다른 역할과 가능성을 가진다. `}</p>
            <p className="s1096 s40">{`우리는 AI를 단순한 도구가 아닌, `}</p>
            <p className="s1096 s40">직접 굴리고 조합하며 실험하는 창작의 재료로 바라본다.</p>
            <p className="s1096 s40">​</p>
            <p className="s1096 s40">{`DING AI LAB은 AI를 탐구의 대상이 아니라 함께 놀며 가능성을 `}</p>
            <p className="s1096">발견하는 대상으로 해석한다.</p>
          </div>
        </div>
        <a className="s1097 s16 s141 s17 s1098 s18 s42 s285 s1099 s1100 s0 s145 s146 s28" data-node-id="772:283">
          <p className="s23 s31 s1101 s32 s27 s0 s28 s29 s33 s149 s1102" data-node-id="772:284">
            VIEW PROJECT
          </p>
        </a>
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="1035:616" data-name="navigationbar">
        <a className="s16 s141 s17 s110 s26 s0 s28" data-node-id="1035:617">
          <div className="s111 s0 s28 s112" data-node-id="1035:618" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="1035:623">
            DING AI LAB
          </p>
        </a>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="1035:624">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="1035:625">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:626">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:627">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <a className="s16 s141 s17 s24 s118 s18 s0 s28 s123" data-node-id="1035:628">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:629">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:630">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine26} />
            </div>
          </a>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="1035:640">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1035:641">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1035:642">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine27} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}